import React from 'react';
import { LoyaltyPoints } from './LoyaltyPoints';
import { FreeGiftBanner } from './FreeGiftBanner';
interface ProductInfoProps {
  product: {
    name: string;
    brand: string;
    price: number;
    originalPrice?: number;
    discount?: number;
    inStock: boolean;
    stockStatus: string;
    tags?: string[];
    loyaltyPoints?: number;
  };
  showStockWithBrand?: boolean;
  simplified?: boolean;
}
export function ProductInfo({
  product,
  showStockWithBrand = false,
  simplified = false
}: ProductInfoProps) {
  return <div className="space-y-6" data-id="element-4879" data-mp="1w3iydv7kgsi3">
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm md:p-5" data-id="element-4880" data-mp="1w4lqg6gml0zl">
        <div className="mb-2 flex flex-wrap items-center gap-2" data-id="element-4881" data-mp="1icxfi6i44ik7">
          <span className="text-sm font-semibold uppercase tracking-wide text-gray-900" data-id="element-4882" data-mp="1n9e5l68vh6zx">{product.brand}</span>
          <a href="#" className="text-xs text-brand hover:underline" data-id="element-4883" data-mp="18dy78p19eoxq">View More</a>
          {showStockWithBrand && <span className={`ml-auto whitespace-nowrap text-xs font-bold ${product.inStock ? 'text-brand' : 'text-red-600'}`} data-id="element-4884" data-mp="1daokl4loj6fg">· {product.stockStatus}</span>}
        </div>
        <h1 className="mb-3 text-xl font-semibold leading-tight text-gray-900 md:text-2xl" data-id="element-4885" data-mp="2wuzni95vwzfm">{product.name}</h1>
        <div className="mb-4" data-id="element-4886" data-mp="3auivn1yp4arx">
          <div className="mb-2 flex items-baseline gap-3" data-id="element-4887" data-mp="3atpm5t8cr763">
            <span className="text-3xl font-bold text-red-600" data-id="element-4888" data-mp="36s4844k30mub">SAR {product.price.toFixed(2)}</span>
            {product.originalPrice && <span className="text-lg text-gray-400 line-through" data-id="element-4889" data-mp="2j3uw1uco7dgd">SAR {product.originalPrice.toFixed(2)}</span>}
          </div>
          {product.discount && product.discount > 0 && <span className="inline-block rounded-full bg-red-100 px-3 py-1 text-sm font-bold text-red-700" data-id="element-4890" data-mp="2rvwtrkvcufmy">Save {product.discount}%</span>}
        </div>
        {!showStockWithBrand && <p className={`mb-4 text-sm font-bold ${product.inStock ? 'text-brand' : 'text-red-600'}`} data-id="element-4891" data-mp="1zf2kdz5twb0q">{product.stockStatus}</p>}
        {!simplified && product.tags && product.tags.length > 0 && <div className="mb-4 flex flex-wrap gap-2" data-id="element-4892" data-mp="1vbe8j4a5yt9o">{product.tags.map(tag => <span key={tag} className="inline-flex items-center rounded-full bg-brand-light px-3 py-1 text-xs font-medium text-brand" data-id="element-4893" data-mp="3uhh0rbhlt9ux">{tag}</span>)}</div>}
        {!simplified && <>
          <FreeGiftBanner data-id="element-4894" data-mp="82e9ichu5wha" />
          {product.loyaltyPoints && <div className="mt-4 border-t border-gray-200 pt-4" data-id="element-4895" data-mp="850f46l621wv"><LoyaltyPoints points={product.loyaltyPoints} data-id="element-4896" data-mp="d0phehoklwwv" /></div>}
        </>}
      </div>
    </div>;
}